import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/stores/authStore";

export function RequireAuth({ children }: { children: ReactNode }) {
  const token = useAuthStore((s) => s.token);
  const location = useLocation();

  if (token) return <>{children}</>;

  const returnTo = `${location.pathname}${location.search}`;
  return <Navigate to={`/login?return_to=${encodeURIComponent(returnTo)}`} replace />;
}
